import { DogIcon } from './DogIcon';

/**
 * author: Michael Irigoyen
 * id 8D6EB954-B4C9-44D5-9E70-C4E186C35957
 * name dog
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dog.svg
 * tags
 * - Animal 
 */
export const EmojiDogIcon = DogIcon;
export default EmojiDogIcon